export default __webpack_public_path__ + "static/media/9.9b86ac81.png";